import React from 'react';
import { TabCarouselSectionStoryblok } from '../../../../types/storyblok';
import * as Tabs from '@radix-ui/react-tabs';
import { Box } from '../../../../base/Box/Box';
import classNames from 'classnames';
import isDarkColour from '../../../../utils/isDarkColour';
import renderStoryblokComponents from '../../../../utils/renderStoryblokComponents';

type Props = Pick<TabCarouselSectionStoryblok, 'cards' | 'colourScheme'>;

export const TabCarouselContentDesktop = ({ cards, colourScheme }: Props) => {
  if (!cards) {
    return null;
  }

  return (
    <Tabs.Root
      className="mx-auto max-w-standard hidden md:block"
      defaultValue={cards?.[0]?._uid}
    >
      <Box
        as="div"
        className="rounded px-28 py-20 bg-ffLightGrey bg-opacity-10 mt-[41px]"
        overlayOverBkg
      >
        <Tabs.List className="mb-6 flex flex-wrap gap-6 md:mb-8">
          {cards?.map((card) => (
            <Tabs.Trigger
              className={classNames(
                'ff-divider ff-type rounded border px-3 py-4 text-p1 lg:px-4 lg:py-5 min-w-[224px]',
                isDarkColour(colourScheme)
                  ? 'data-[state=active]:bg-white data-[state=active]:!text-ffBlack'
                  : 'data-[state=active]:bg-ffBlack data-[state=active]:!text-white'
              )}
              value={card._uid}
            >
              {card?.tabTitle}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {renderStoryblokComponents({ blocks: cards })}
      </Box>
    </Tabs.Root>
  );
};
